/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamAnswerAnsweridAiCorrection200,
  PostApiV1ExamAnswerAnsweridAiCorrection400,
  PostApiV1ExamAnswerAnsweridAiCorrection401,
  PostApiV1ExamAnswerAnsweridAiCorrection404,
  PostApiV1ExamAnswerAnsweridAiCorrection500,
  PostApiV1ExamAnswerAnsweridAiCorrectionMutationResponse,
  PostApiV1ExamAnswerAnsweridAiCorrectionPathParams,
} from "../../types/examCorrectionDashboardController/PostApiV1ExamAnswerAnsweridAiCorrection.ts";
import { examItemAnswerAiCorrectionViewModelSchema } from "../examItemAnswerAiCorrectionViewModelSchema.ts";

export const postApiV1ExamAnswerAnsweridAiCorrectionPathParamsSchema = z.object(
  {
    answerId: z.coerce.number().int(),
  },
) as unknown as ToZod<PostApiV1ExamAnswerAnsweridAiCorrectionPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1ExamAnswerAnsweridAiCorrection200Schema = z.lazy(
  () => examItemAnswerAiCorrectionViewModelSchema,
) as unknown as ToZod<PostApiV1ExamAnswerAnsweridAiCorrection200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ExamAnswerAnsweridAiCorrection400Schema =
  z.any() as unknown as ToZod<PostApiV1ExamAnswerAnsweridAiCorrection400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamAnswerAnsweridAiCorrection401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamAnswerAnsweridAiCorrection401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ExamAnswerAnsweridAiCorrection404Schema =
  z.any() as unknown as ToZod<PostApiV1ExamAnswerAnsweridAiCorrection404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamAnswerAnsweridAiCorrection500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamAnswerAnsweridAiCorrection500>;

export const postApiV1ExamAnswerAnsweridAiCorrectionMutationResponseSchema =
  z.lazy(
    () => postApiV1ExamAnswerAnsweridAiCorrection200Schema,
  ) as unknown as ToZod<PostApiV1ExamAnswerAnsweridAiCorrectionMutationResponse>;
